export const DEFAULT_PAGE = 1;
export const DEFAULT_ITEMS_PER_PAGE = 20;

export const SUBDOMAIN_HEADER = 'X-Subdomain';

export const AI_LOGIN_TYPE = 'ai_login';

export const REDIRECT_MAP: Record<string, string> = {
  'customer-signin': 'login',
  'customer-signup': 'register',
  ai_login: AI_LOGIN_TYPE
};

export const DEFAULT_DATE_OF_BIRTH = '1900-01-01';
